module.exports = __webpack_public_path__ + "img/Icon-download.90cc9909.svg";